/* eslint-disable linebreak-style */
import React, { ReactElement } from 'react';
import { Form } from 'react-bootstrap';
import { getIn, FormikProps } from 'formik';
import { addPhoneFormatting } from '../../../utils/formatters';

type PhoneFieldInput = {
  formikProps: FormikProps<any>
  fieldName: string,
  visibleName: string,
  showLabel?: boolean
  extraClassValues?: string,
  placeholder: string,
  onChangeCallback?:
    (val: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>)=>void,
}

const removeNonNumbers = (value:string) => {
  return value.replace(/\D/g, '');
};

const PhoneField: React.FC<PhoneFieldInput> = (
  props: PhoneFieldInput,
): ReactElement => {
  const {
    fieldName,
    visibleName,
    showLabel = true,
    extraClassValues = '',
    placeholder,
    // @ts-ignore
    onChangeCallback,
    formikProps,
  } = props;
  const {
    handleBlur,
    values,
    touched,
    errors,
    setFieldValue,
    setFieldTouched,
  } = formikProps;
  const labelElement = showLabel && <Form.Label>{visibleName}</Form.Label>;
  return (
    <Form.Group controlId="formPhone" className={extraClassValues}>
      {labelElement}
      <Form.Control
        type="text"
        placeholder={placeholder}
        value={addPhoneFormatting(getIn(values, fieldName))}
        isInvalid={getIn(touched, fieldName) && getIn(errors, fieldName)}
        onChange={(value) => {
          setFieldValue(fieldName, removeNonNumbers(value.currentTarget.value), true);
          if (onChangeCallback) {
            onChangeCallback(value);
          }
        }}
        onBlur={(e) => {
          handleBlur(e);
          setFieldTouched(fieldName, true);
        }}
      />
      <Form.Control.Feedback type="invalid">
        {getIn(errors, fieldName)}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export default PhoneField;
